// extracted by mini-css-extract-plugin
export default {"container":"containers-Container-_index-module_container"};